import React from 'react';

export const INDEX_URL='/';
export const SITE_URL='https://wa.babysofts.in/';
export const API_URL = 'https://api.babysofts.in/whats-app/api/';
export const SITE_TITLE='WhatsApp';
export const MAIL_FORMAT = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NUMBER_FORMATE = /^\d+$/;

export const GetRedirectUrl = () => {
    const path_name = window.location.pathname;
    return path_name.replace(/\//g, '');
}

export const ucwords = (str) => {
    if (!str) return ''; // Add a check for undefined or empty string
    return str.toLowerCase().replace(/\b\w/g, function(char) {
      return char.toUpperCase();
    });
}
export const firstChar = (str) => {
    return ucwords(Array.from(str)[0]);
}